export default "__VITE_ASSET__VD7xGXJF__"